const YOUNGONE_FACTORYIDS = ['vnm-you-ynl', 'bgd-you-ks21'];

const FACTORY_ID_LOGO = [
  {
    factoryIds: YOUNGONE_FACTORYIDS,
    factoryLogo: 'assets/common/factory-logos/youngone.png',
  },
];

export function getFactoryLogoFromId(factoryId: string): string {
  return (
    FACTORY_ID_LOGO.find((item) => item.factoryIds.includes(factoryId))?.factoryLogo ??
    '/assets/common/solvei8-logo.svg'
  );
}
